// Use require.context to load all team logos
const teamLogosContext = require.context('../assets/logos/logo-teams', false, /\.(png|jpg|jpeg|svg|webp)$/);

// Create a map of filename to imported logo
const teamLogosMap = {};
teamLogosContext.keys().forEach((item) => {
  const fileName = item.replace('./', '');
  teamLogosMap[fileName] = teamLogosContext(item);
});

// Default logo
const defaultLogo = teamLogosMap['Juventus_(white_on_black).svg'] || null;

// Helper function to get team logo
export const getTeamLogoPath = (logoFileName) => {
  // Try exact match first
  if (teamLogosMap[logoFileName]) {
    return teamLogosMap[logoFileName];
  }
  
  // Try case-insensitive match
  const matchedKey = Object.keys(teamLogosMap).find(
    key => key.toLowerCase() === logoFileName.toLowerCase()
  );
  
  if (matchedKey) {
    return teamLogosMap[matchedKey];
  }
  
  console.warn(`Team logo not found: ${logoFileName}, using default`);
  return defaultLogo;
};
